import * as React from 'react';

const NoIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#B31E00"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="M15.6 15.6 8.4 8.4m0 7.2 7.2-7.2"
    ></path>
  </svg>
);

export default NoIcon;
